import React from 'react';
import s from './style.module.css';

class ContactTextarea extends React.Component {
    render(props) {
        return (
        	<div className={s.inputFieldWrapper}>
                <label className={s.inputLabel} htmlFor={this.props.name}>{this.props.labelText} {this.props.required && <span className={s.asterix}>*</span>}</label>
        		<textarea name={this.props.name} onChange={this.props.onChange} value={ this.props.value || ''} maxLength={this.props.maxlength} required={this.props.required} className={ `${this.props.className} ${s.textField}`}></textarea>
        		<label className={`${typeof this.props.error === 'undefined' ? '' : s.mActive} ${s.error} `}></label>
        		<label className={`${typeof this.props.error === 'undefined' ? '' : s.mActive} ${s.errorText} `}>{this.props.error}</label>
        	</div>
        )
    }
}

export default ContactTextarea;